import { Card } from "components/Card/Card";
import { Form, InputConfig } from "components/Form/Form";
import { useLangContext } from "context/Lang";


interface LessonFormProps {
    lesson?: LessonType;
    loading?: boolean;
    onSubmit: (data: LessonType) => void;
}





export function LessonForm({
    lesson,
    loading,
    onSubmit,
}: LessonFormProps) {

    const { gW } = useLangContext();

    const lessonFormInputs: InputConfig<LessonType>[] = [
        {
            name: "name",
            label: gW("lesson-name"),
            type: "text",
            placeholder: gW("enter-lesson-name"),
            required: true,
        },
        {
            name: "description",
            label: gW("description"),
            type: "text",
            placeholder: gW("lesson-description"),
        },
        {
            name: "image",
            label: gW("lesson-image"),
            type: "file",
            accept: "image/*",
        },
        {
            name: "status",
            label: gW("status"),
            type: "select",
            required: true,
            options: [
                { label: gW("active"), value: 1 },
                { label: gW("inactive"), value: 0 },
            ],
        },
    ];



    return (
        <Form<LessonType>
            className=""
            inputs={lessonFormInputs}
            data={lesson}
            submitTitle={gW(lesson ? "update-lesson" : "create-lesson")}
            loading={loading}
            onSubmit={onSubmit}
            header={
                <h2 className="text-xl font-semibold text-primary-600">
                    {gW(lesson ? "update-lesson" : "create-lesson")}
                </h2>
            }
        />
    );
}